<template>
  <exercise-logic
    exCollection="trafficExCollection"
    @ready="onReady"
    @error="onError"
    @saved="onSaved"
    @savedNext="onSavedNext"
    @loadedEx="onLoadedEx"
    @loadedRefs="onLoadedRefs"
    :doc="doc"
    :shared="false"
  >
    <template slot-scope="{ saveExercise }">
      <v-row>
        <v-col sm="12" lg="10" offset-lg="1">
          <v-row>
            <v-col cols="4" class="mb-4">
              <h2
                class="headline"
                v-text="$t('exercise_traffic_lights.step1.title')"
              ></h2>
            </v-col>
            <v-col cols="8" lg="6" class="mb-4">
              <p
                v-for="(item, index) in $t(
                  'exercise_traffic_lights.step1.description'
                )"
                :key="index"
                v-text="item"
              />
            </v-col>
          </v-row>
          <v-row v-if="doc">
            <v-col cols="4">
              <unit-traffic
                v-model="doc.stop"
                :limit="3"
                name="stop"
                above="3 things that we do now and should"
                title="STOP"
                below="Doing"
                color="red"
              ></unit-traffic>
            </v-col>
            <v-col cols="4">
              <unit-traffic
                v-model="doc.keep"
                :limit="3"
                name="keep"
                above="3 things that we do now and should"
                title="KEEP"
                below="Doing"
                color="orange"
              ></unit-traffic>
            </v-col>
            <v-col cols="4">
              <unit-traffic
                v-model="doc.start"
                :limit="3"
                name="start"
                above="3 things that we don't do now and should"
                title="START"
                below="Doing"
                color="green"
              ></unit-traffic>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <bottom-navigation
        :save="true"
        :next="false"
        :prev="false"
        :gridView="false"
        :gridToggle="false"
        @save="saveExercise"
        @prev="prevStep"
        @next="saveExercise(false)"
      >
      </bottom-navigation>

      <v-dialog v-model="dialog" max-width="500">
        <v-card>
          <v-card-title
            class="headline"
            v-text="$t('exercise_service.saved.title')"
          ></v-card-title>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="amber" text @click="closeDialog">
              Close
            </v-btn>

            <v-btn
              color="amber accent-1"
              text
              :to="`/users/project/${$route.params.id}`"
            >
              Back to Project
            </v-btn>
            <v-btn color="amber accent-1" text to="/users/dashboard">
              Back to Dashboard
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </exercise-logic>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogic } from "@/components/exercises";
import { UnitTraffic } from "@/components/units";

// const fb = require("@/firebaseConfig.js");

export default {
  name: "UserTraffic",
  data() {
    return {
      e1: 1,
      doc: {
        stop: [{ title: "" }, { title: "" }, { title: "" }],
        keep: [{ title: "" }, { title: "" }, { title: "" }],
        start: [{ title: "" }, { title: "" }, { title: "" }],
      },
      tabs: [{ title: "Traffic Lights", count: 1 }],
      userSelected: null,
      debug: false,
      dialog: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogic,
    UnitTraffic,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },

  mounted() {},
  methods: {
    nextStep() {
      this.e1++;
      // this.saveExercise(false);
    },
    prevStep() {
      this.e1--;
      // this.saveExercise(false);
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      console.log("saved");
      this.dialog = true;
    },
    onLoadedRefs(refs) {
      console.log("loaded", refs);
    },
    onLoadedEx(ex) {
      this.doc = ex.doc;
      this.exercise = ex;
    },
    onSavedNext() {
      this.nextStep();
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss"></style>
